import { render } from "./TeamChangeActivityBadge.vue?vue&type=template&id=27d84de0&scoped=true"
import script from "./TeamChangeActivityBadge.vue?vue&type=script&lang=js"
export * from "./TeamChangeActivityBadge.vue?vue&type=script&lang=js"

import "./TeamChangeActivityBadge.vue?vue&type=style&index=0&id=27d84de0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27d84de0"

export default script